import React, { Component, useRef } from "react";
import TickIcon from "../../assets/thankyou.svg";
import addIcon from "../../assets/plus.svg";
import APACForm from "../Forms/APACForm";
import CountryDropdown from "../CommonComponent/CountryDropdown";
import UKForm from "../Forms/UKForm";
import {
  Input,
  Label,
  Hint,
  Heading,
  Tooltip,
  GlyphInfo,
  TooltipButton,
  Modal,
  ModalBody,
  ModalFooter,
  RadioGroup,
  RadioButton,
  Button,
  Alert,
} from "@americanexpress/dls-react";

import "./personalDetails.css";
import { withTranslation } from "react-i18next";
import AddAccess from "../AddAccessPage/AddAccess";
import closeIcon from "../../assets/closeIcon.svg";
import {
  APAC_COUNTRIES,
  EUROZONE_COUNTRIES,
  getDocMandatoryCountries,
  getVerificationWordMandatoryCountries,
  JOURNEY_TYPE,
  MODIFY_ACCESS_OPTIONAL_COUNTRIES,
  REGEX,
  UK_COUNTRIES,
} from "../Common/constants";
import FormikContainer from "../Forms/FormikContainer";
import {
  getCountryZone,
  getTransArr,
  getPAScreeningCountries, isBirthYearRequiredHelper,
} from "../Common/utils";

class PersonalDetails extends Component {
  constructor(props) {
    super(props);
    this.formikRef = React.createRef();

    this.state = {
      user: {
        userId: "",
        language: "en",
        existingProgramAdministrator: false,
        title: "",
        titleOthers: "",
        firstName: "",
        fullMiddleName: "",
        lastName: "",
        modifyFirstName: "",
        modifyMiddleName: "",
        modifyLastName: "",
        paAddress: "",
        paPostcode: "",
        phoneNumber: "",
        emailId: "",
        modifyEmail: "",
        day: "",
        month: "",
        fullDateOfBirth: "",
        birthMonthDay: "",
        year: "",
        verificationWord: "",
        verificationPin: "",
        country: "",
        countryUK: "",
        paCountry: "",
        paExistingInfo: "",
        motherMaidenName: "",
        nationality: "",
        verificationPinUK: "",
        memorableDate: "",
        clueMemorableDate: "",
        bussRegName: "",
        bussRegAddress: "",
        bussRegPostcode: "",
        bussRegCountry: "",
        paScreeningFiles: [],
        supportingFiles: [],
        globalDataTransFiles: [],
        residenceAddress: {
          residenceAddressLine: "",
          cityOrSubrub: "",
          stateOrPrefecture: "",
          postCode: "",
        },
        empBussName: "",
        corrAddress: "",
        corrPostcode: "",
        corrCountry: "",
        vPinDay: "",
        vPinMonth: "",
        access: [],
        selfenroll: "",
        authorizedSignatories: [],
        showCheckBox: false,
        modifyCheckBox: false,
        showOtherTitle: false,
        eeaCheckbox: false,
      },

      users: [
        {
          userId: "",
          language: "en",
          existingProgramAdministrator: false,
          title: "",
          titleOthers: "",
          firstName: "",
          fullMiddleName: "",
          lastName: "",
          modifyFirstName: "",
          modifyMiddleName: "",
          modifyLastName: "",
          paAddress: "",
          paPostcode: "",
          phoneNumber: "",
          emailId: "",
          modifyEmail: "",
          day: "",
          month: "",
          year: "",
          verificationWord: "",
          fullDateOfBirth: "",
          birthMonthDay: "",
          verificationPin: "",
          country: "",
          countryUK: "",
          paCountry: "",
          paExistingInfo: "",
          motherMaidenName: "",
          nationality: "",
          verificationPinUK: "",
          memorableDate: "",
          clueMemorableDate: "",
          bussRegName: "",
          bussRegAddress: "",
          bussRegPostcode: "",
          bussRegCountry: "",
          supportingFiles: [],
          globalDataTransFiles: [],
          residenceAddress: {
            residenceAddressLine: "",
            cityOrSubrub: "",
            stateOrPrefecture: "",
            postCode: "",
          },
          empBussName: "",
          corrAddress: "",
          corrPostcode: "",
          corrCountry: "",
          vPinDay: "",
          vPinMonth: "",
          access: [],
          selfenroll: "",
          authorizedSignatories: [],
          showCheckBox: false,
          modifyCheckBox: false,
          showOtherTitle: false,
          eeaCheckbox: false,
        },
      ],

      showAccessModal: false,
      accessIndx: 0,
      error: false,
      isEditing: false,
      displayaccess: true,
      success: false,
      count: 0,
      submit: false,
      edit: false,
      index: -1,
      show: false,
      newuseraccess: false,
      accessobj: {
        country: "",
        controlAccountNumber: "",
        functions: [],
      },
      displayuserModal: false,
      showAllUsers: false,
      showUK: false,
      showAPAC: false,
      showEurozone: false,
      invalidYear: false,
    };
  }

  componentDidMount() {
    const { user, modifyCheckBox, showCheckBox, modifyUser } = this.props;
    window.scrollTo(0, 0);
    if (modifyUser) {
      localStorage.setItem("modify", "true");
    } else {
      localStorage.setItem("modify", "false");
    }
    localStorage.setItem("modify", modifyUser);
    if (user) {
      this.setState({ user, modifyCheckBox, showCheckBox });
      this.updateSavobj("country", user.country);
      this.setState(() => ({
        submit: false,
      }));
    }
  }

  toggleAccess = () =>
    this.setState({ showAccessModal: !this.state.showAccessModal });

  mapModifyUserIdentityFields = (values = {}, fallbackUser = {}) => {
    const mapped = { ...values };

    if (mapped.currentFirstName && !mapped.firstName) {
      mapped.firstName = mapped.currentFirstName;
    }
    if (mapped.currentFullLastName && !mapped.lastName) {
      mapped.lastName = mapped.currentFullLastName;
    }
    if (mapped.currentCompanyEmail && !mapped.emailId) {
      mapped.emailId = mapped.currentCompanyEmail;
    }

    if (!mapped.firstName && fallbackUser.firstName) {
      mapped.firstName = fallbackUser.firstName;
    }
    if (!mapped.lastName && fallbackUser.lastName) {
      mapped.lastName = fallbackUser.lastName;
    }
    if (!mapped.emailId && fallbackUser.emailId) {
      mapped.emailId = fallbackUser.emailId;
    }

    return mapped;
  };

  getFile = (key, fileUk) => {
    const { user } = this.state;
    let filesUk = user.supportingFiles;
    filesUk.push(fileUk);
    user[key] = filesUk;
    this.setState({ user });
  };

  getEeaFile = (key, fileUk) => {
    const { user } = this.state;
    let filesUk = user.globalDataTransFiles;
    filesUk.push(fileUk);
    user[key] = filesUk;
    this.setState({ user });
  };

  onNext = async () => {
    this.setState(() => ({
      submit: true,
    }));
    if (this.formikRef?.current) {
      return this.formikRef.current.submitForm();
    }

    return true;
  };

  editSavobj = (key, value) => {
    const { user } = this.state;
    user[key] = value;
    this.setState({ user });
  };

  updateadd = (key, value) => {
    const { additionalNewUser, addNewUser, user } = this.props;
    if (addNewUser || additionalNewUser) {
      const { user } = this.state;
      user.residenceAddress[key] = value;
      this.setState({ user });
    } else {
      user.residenceAddress[key] = value;
      this.setState({ user });
    }
  };

  updateSavobj = (key, value) => {
    const { t, additionalNewUser, addNewUser } = this.props;
    const selectedCountry = key === "country" ? value : this.state.user.country;
    const transUKCountries = getTransArr(UK_COUNTRIES, t);
    const transAPACCountries = getTransArr(APAC_COUNTRIES, t);
    const transEurozoneCountries = getTransArr(EUROZONE_COUNTRIES, t);
    const isUK = getCountryZone(selectedCountry, transUKCountries);
    const isAPAC = getCountryZone(selectedCountry, transAPACCountries);
    const isEUROZONE = getCountryZone(selectedCountry, transEurozoneCountries);

    if (isUK) {
      this.setState({ showUK: true, showAPAC: false, showEurozone: false });
    } else if (isAPAC) {
      this.setState({ showUK: false, showAPAC: true, showEurozone: false });
    } else if (isEUROZONE) {
      this.setState({ showAPAC: false, showUK: false, showEurozone: true });
    } else {
      this.setState({ showAPAC: false, showUK: false, showEurozone: false });
    }

    if (this.props.disable) {
      this.props.disable(true);
    }

    if (addNewUser || additionalNewUser) {
      const { user } = this.state;
      user[key] = value;
      this.setState({ user });
    } else {
      const { user } = this.props;

      if (key === "userId") {
        user[key] = value;
      }
      user[key] = value;
      if (key === "day") {
        user["vPinDay"] = value;
      }
      if (key === "month") {
        user["vPinMonth"] = value;
      }
      this.setState({ user });
    }
    if (key === "year") {
      this.setState({
        invalidYear: !value?.match(/^\d{4}$/) && this.state.showUK,
      });
    }

    this.setState(
      { user: this.props.user ? this.props.user : this.state.user },
      () => {
        if (
          this.state.user.modifyFirstName !== "" ||
          this.state.user.modifyMiddleName !== "" ||
          this.state.user.modifyLastName !== ""
        ) {
          this.setState((currentState) => ({
            user: {
              ...currentState.user,
              showCheckBox: true,
            },
          }));
        }

        if (
          this.state.user.modifyFirstName === "" &&
          this.state.user.modifyMiddleName === "" &&
          this.state.user.modifyLastName === ""
        ) {
          this.setState((currentState) => ({
            user: {
              ...currentState.user,
              showCheckBox: false,
              modifyCheckBox: false,
              supportingFiles: [],
            },
          }));
        }

        if (this.state.user.title === "Others") {
          this.setState((currentState) => ({
            user: {
              ...currentState.user,
              showOtherTitle: true,
            },
          }));
        }

        if (this.state.user.title !== "Others") {
          this.setState((currentState) => ({
            user: {
              ...currentState.user,
              showOtherTitle: false,
            },
          }));
        }
      },
    );
  };

  onChangeTitle = (key, value) => {
    const { user } = this.state;
    user[key] = value;
    this.setState({ user });
  };

  getDetails = () => {
    this.setState({ error: true });
  };

  handleAddAccess = (access, indx) => {
    if (this.props.disable) {
      this.props.disable(true);
    }
    this.setState({ accessobj: access, accessIndx: indx });
    this.setState({ showAccessModal: true });
  };

  deleteAccess = (index) => {
    const { user } = this.state;
    const tempAccess = [...user.access];
    tempAccess.splice(index, 1);
    user.access = [...tempAccess];
    this.setState({ user });
  };

  getValue = (value) => {
    this.setState({ isEditing: value });
  };

  getAccessArray = (value, accessEdit, i) => {
    const { access } = this.state.user;

    if (accessEdit) {
      access[this.state.accessIndx] = value;
      this.setState({ displayaccess: true });
    } else {
      access.push(value);
      this.setState({ displayaccess: true });
    }
    this.toggleAccess();
  };

  checkEmpty = (obj) => {
    const { t } = this.props;
    const { showAPAC, showUK, showEurozone, user } = this.state;
    const { emailId, modifyCheckBox, eeaCheckbox } = user;

    /* APAC ADD & MODIFY JOURNEY STARTS */
    if (showAPAC) {
      if (
        obj.firstName === "" ||
        obj.lastName === "" ||
        obj.emailId === "" ||
        obj.phoneNumber === "" ||
        obj.selfenroll === ""
      ) {
        return false;
      }

      if (this.props.i18n.language === "en") {
        if (
          obj.firstName !== "" &&
          obj.firstName.match(/^[a-zA-Z -]*$/) === null
        ) {
          return false;
        }
        if (
          obj.lastName !== "" &&
          obj.lastName.match(/^[a-zA-Z -]*$/) === null
        ) {
          return false;
        }
        if (
          obj.emailId !== "" &&
          obj.emailId.match(
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*$/,
            ///^[a-zA-Z0-9.]+[-._a-z]*@[a-zA-Z0-9-_]+\.[a-zA-Z.-_]+$/
          ) === null
        ) {
          return false;
        }
        if (
          this.props.mailext !== undefined &&
          emailId.substring(emailId.indexOf("@") + 1) !== this.props.mailext
        ) {
          return false;
        }
      }

      //Check Phone Number is valid
      if (
        obj.phoneNumber !== "" &&
        obj.phoneNumber.match(/^[0-9+-]*$/) === null
      ) {
        return false;
      }

      //Check day is valid
      if (
        obj.day !== "" &&
        (obj.day.match(/^[0-9]*$/) === null ||
          obj.day.length > 2 ||
          parseInt(obj.day) <= 0)
      ) {
        return false;
      }

      //Check month is valid
      if (
        obj.month !== "" &&
        (obj.month.match(/^[0-9]*$/) === null ||
          obj.month.length > 2 ||
          parseInt(obj.month) > 12 ||
          obj.month === "00")
      ) {
        return false;
      }

      //Check if year is valid
      if (
        (obj.year !== "" && obj.year.match(/^[0-9]*$/) === null) ||
        (obj.year.length !== 4 && obj.year.length > 0)
      ) {
        return false;
      }

      if (this.props.modifyUser) {
        if (obj.userId === "" || obj.userId === undefined) {
          return false;
        }
      }

      if (!this.props.modifyUser) {
        for (let key in obj) {
          const { t } = this.props;
          if (key === "residenceAddress") {
            let o = obj["residenceAddress"];
            for (let k in o) {
              if (o[k] === "") {
                if (
                  (obj["country"] === t("access.JAPAN") ||
                    obj["country"] === t("access.NEWZEALAND")) &&
                  obj["selfenroll"] === "2"
                ) {
                  return false;
                } else {
                  continue;
                }
              }
            }
          }

          if (
              isBirthYearRequiredHelper(t, obj.selfenroll, obj.country)
          ) {
            if (obj.year === "") {
              return false;
            }
          }
          if (obj[key] === "") {
            if (
              key === "existingProgramAdministrator" ||
              key === "year" ||
              key === "fullDateOfBirth" ||
              key === "title" ||
              key === "titleOthers" ||
              key === "fullMiddleName" ||
              key === "paAddress" ||
              key === "paPostcode" ||
              key === "countryUK" ||
              key === "paCountry" ||
              key === "paExistingInfo" ||
              key === "motherMaidenName" ||
              key === "nationality" ||
              key === "verificationPinUK" ||
              key === "memorableDate" ||
              key === "clueMemorableDate" ||
              key === "bussRegName" ||
              key === "bussRegAddress" ||
              key === "bussRegPostcode" ||
              key === "bussRegCountry" ||
              key === "modifyFirstName" ||
              key === "modifyMiddleName" ||
              key === "modifyLastName" ||
              key === "modifyEmail" ||
              key === "empBussName" ||
              key === "corrAddress" ||
              key === "corrPostcode" ||
              key === "corrCountry" ||
              key === "userId"
            ) {
              continue;
            }
            if (key === "verificationWord") {
              if (getVerificationWordMandatoryCountries(t).includes(obj.country)) {
                if (obj[key] === "") return false;
                continue;
              }
              if (obj["lastName"].length > 3) {
                obj[key] = obj["lastName"];
                continue;
              } else {
                obj[key] = obj["firstName"];
                continue;
              }
            }

            //Verification Pin
            if (key === "vPinDay") {
              if (obj["day"].length > 0) {
                obj[key] = obj["day"];
                continue;
              }
            }
            if (key === "vPinMonth") {
              if (obj["month"].length > 0) {
                obj[key] = obj["month"];
                continue;
              }
            }

            return false;
          }
        }
      }
      const journeyType = this.props.modifyUser ? JOURNEY_TYPE.MODIFY : JOURNEY_TYPE.ADD;
      const mandatoryDocumentCountries = getDocMandatoryCountries(t, journeyType, obj.selfenroll);
      const requiredScreening = getPAScreeningCountries(t).filter((country) =>
        mandatoryDocumentCountries.includes(country),
      );
      if (
        requiredScreening.includes(obj.country) &&
        (!obj.paScreeningFiles || obj.paScreeningFiles.length === 0)
      )
        return false;
      console.log("inside APAC this.state.user = ", this.state.user);
      return true;
    }
    /* END OF APAC ADD & MODIFY JOURNEY */

    /* UK ADD JOURNEY STARTS */
    if (!this.props.modifyUser && showUK) {
      console.log("inside UK Add this.state.user = ", this.state.user);
      if (
        obj.selfenroll === "" ||
        obj.title === "" ||
        obj.firstName === "" ||
        obj.lastName === "" ||
        obj.paAddress === "" ||
        obj.paPostcode === "" ||
        obj.countryUK === "" ||
        obj.paCountry === "" ||
        obj.motherMaidenName === "" ||
        obj.nationality === "" ||
        obj.verificationPinUK === "" ||
        obj.memorableDate === "" ||
        obj.clueMemorableDate === "" ||
        obj.bussRegName === "" ||
        obj.bussRegAddress === "" ||
        obj.bussRegPostcode === "" ||
        obj.bussRegCountry === "" ||
        (obj.title === "Others" && obj.titleOthers === "") ||
        obj.phoneNumber === "" ||
        obj.emailId === "" ||
        obj.day === "" ||
        obj.month === "" ||
        obj.year === ""
      ) {
        return false;
      }

      if (
        obj.firstName !== "" &&
        obj.firstName.match(/^[a-zA-Z -]*$/) === null
      ) {
        return false;
      }
      if (obj.lastName !== "" && obj.lastName.match(/^[a-zA-Z -]*$/) === null) {
        return false;
      }
      if (
        obj.emailId !== "" &&
        obj.emailId.match(
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*$/,
          ///^[a-zA-Z0-9.]+[-._a-z]*@[a-zA-Z0-9-_]+\.[a-zA-Z.-_]+$/
        ) === null
      ) {
        return false;
      }

      //Check day is valid
      if (
        obj.day !== "" &&
        (obj.day.match(/^[0-9]*$/) === null ||
          obj.day.length > 2 ||
          parseInt(obj.day) <= 0 ||
          parseInt(obj.day) > 31)
      ) {
        return false;
      }

      //Check month is valid
      if (
        obj.month !== "" &&
        (obj.month.match(/^[0-9]*$/) === null ||
          obj.month.length > 2 ||
          parseInt(obj.month) > 12 ||
          obj.month === "00")
      ) {
        return false;
      }

      //Check Phone Number is valid
      if (
        obj.phoneNumber !== "" &&
        obj.phoneNumber.match(/^[0-9+-]*$/) === null
      ) {
        return false;
      }

      //check verification Pin
      if (
        obj.verificationPinUK.match(/^[0-9+-]*$/) === null ||
        obj.verificationPinUK.length < 4
      ) {
        return false;
      }

      //check mermorable date
      if (
        obj.memorableDate.match(/^[0-9+-]*$/) === null ||
        obj.memorableDate.length < 4
      ) {
        return false;
      }
      if (obj.year.length > 0 && obj.year.length < 4) {
        //Check if year is valid
        this.setState({ invalidYear: true });
        return false;
      }

      if (eeaCheckbox && obj.globalDataTransFiles.length == 0) {
        return false;
      }

      if (
        this.props.mailext !== undefined &&
        emailId.substring(emailId.indexOf("@") + 1) !== this.props.mailext
      ) {
        return false;
      }
      this.setState({ invalidYear: false });
      return true;
    }
    /* END OF UK ADD JOURNEY */

    /* UK MODIFY JOURNEY STARTS */
    if (this.props.modifyUser && showUK) {
      console.log("inside UK Modify this.state.user = ", this.state.user);
      if (
        obj.selfenroll === "" ||
        obj.firstName === "" ||
        obj.lastName === "" ||
        obj.emailId === "" ||
        obj.bussRegName === "" ||
        obj.bussRegAddress === "" ||
        obj.bussRegPostcode === "" ||
        obj.bussRegCountry === "" ||
        (obj.title === "Others" && obj.titleOthers === "")
      ) {
        return false;
      }

      if (modifyCheckBox && obj.supportingFiles.length == 0) {
        return false;
      }

      if (eeaCheckbox && obj.globalDataTransFiles.length == 0) {
        return false;
      }

      if (
        (obj.modifyFirstName !== "" ||
          obj.modifyMiddleName !== "" ||
          obj.modifyLastName !== "") &&
        !modifyCheckBox &&
        obj.supportingFiles.length == 0
      ) {
        return false;
      }
      if (
        obj.firstName !== "" &&
        obj.firstName.match(/^[a-zA-Z -]*$/) === null
      ) {
        return false;
      }
      if (obj.lastName !== "" && obj.lastName.match(/^[a-zA-Z -]*$/) === null) {
        return false;
      }
      if (
        obj.emailId !== "" &&
        obj.emailId.match(
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*$/,
          ///^[a-zA-Z0-9.]+[-._a-z]*@[a-zA-Z0-9-_]+\.[a-zA-Z.-_]+$/
        ) === null
      ) {
        return false;
      }

      if (
        this.props.mailext !== undefined &&
        emailId.substring(emailId.indexOf("@") + 1) !== this.props.mailext
      ) {
        return false;
      }

      return true;
    }
    /* END OF UK MODIFY JOURNEY  */

    if (!this.props.modifyUser && showEurozone) {
      return !!(
        obj.firstName &&
        obj.lastName &&
        obj.emailId &&
        obj.phoneNumber
      );
    }

    return true;
  };

  shouldSkipAccessValidationForModify = () => {
    const { modifyUser, t } = this.props;
    const { user } = this.state;
    if (!modifyUser) return false;
    return MODIFY_ACCESS_OPTIONAL_COUNTRIES(t).has(user.country);
  };

  newAddUser = async () => {
    const { t } = this.props;
    const { user } = this.state;
    const countryUK = t("access.UNITEDKINGDOM");
    const isUserCountryUK = user.country === countryUK;

    if (user.selfenroll === "1") {
      user.existingProgramAdministrator = true;
    }

    if (user.day.length === 1) {
      user.day = `0${user.day}`;
    }

    if (user.month.length === 1) {
      user.month = `0${user.month}`;
    }

    if (user.day !== "" && user.month !== "") {
      user.verificationPin = `${user.day}${user.month}`;
      user.birthMonthDay = `${user.day}/${user.month}`;
    }
    if (user.year !== "") {
      user.fullDateOfBirth = `${user.day}/${user.month}/${user.year}`;
    }
    if (isUserCountryUK) {
      user.verificationPin = "";
    }
    const isFormikValid = await this.onNext();
    const formikValues = this.formikRef?.current?.getValues?.() || {};
    const baseUser = this.state.user;

    let mappedFormikValues = { ...formikValues };
    if (this.props.modifyUser) {
      mappedFormikValues = this.mapModifyUserIdentityFields(formikValues, baseUser);
    }

    const currentUser = { ...baseUser, ...mappedFormikValues };
    const isValid = this.checkEmpty(currentUser);
    const shouldSkipAccessValidationForModify  = this.shouldSkipAccessValidationForModify();

    if (this.props.modifyUser) {
      this.setState({ user: currentUser });
    }

    if (currentUser.country && isValid) {
      if (isFormikValid && shouldSkipAccessValidationForModify) {
        if (this.props.disable) {
          this.props.disable(false);
        }
        this.setState({ newuseraccess: true, displayuserModal: true });
      } else if (isUserCountryUK && this.props.modifyUser) {
        if (this.props.disable) {
          this.props.disable(false);
        }
        this.setState({ newuseraccess: true, displayuserModal: true });
      } else if (currentUser.access.length >= 1) {
        if (!isFormikValid) return;
        if (this.props.disable) {
          this.props.disable(false);
        }
        this.setState({ newuseraccess: true, displayuserModal: true });
      }
    }
  };

  ModalShow = () => {
    const { setUsers, selectedIndex, addNewUser, additionalNewUser } =
      this.props;
    let user = { ...this.state.user };
    if (this.props.modifyUser) {
      const formikValues = this.formikRef?.current?.getValues?.() || {};
      if (Object.keys(formikValues).length > 0) {
        const mapped = this.mapModifyUserIdentityFields(formikValues, user);
        user = { ...user, ...mapped };
      }
    }

    const { showCheckBox, modifyCheckBox } = user;
    this.setState({ displayuserModal: false });
    if (addNewUser) {
      setUsers(user, "addNewUser", modifyCheckBox, showCheckBox);
    } else if (additionalNewUser) {
      setUsers(user, "additionalNewUser", modifyCheckBox, showCheckBox);
    } else {
      setUsers(user, "modify", modifyCheckBox, showCheckBox, selectedIndex);
    }
  };

  deleteUserDetails = () => {
    this.props.deleteUser(this.props.selectedIndex);
    this.props.disable(false);
  };

  handleNameProofCheckbox = () => {
    this.setState((currentState) => ({
      user: {
        ...currentState.user,
        modifyCheckBox: !this.state.user.modifyCheckBox,
      },
    }));
    if (this.state.user.modifyCheckBox) {
      this.setState((currentState) => ({
        user: {
          ...currentState.user,
          modifyFirstName: "",
          modifyMiddleName: "",
          modifyLastName: "",
        },
      }));
    }
  };

  handleEEAProofCheckbox = () => {
    this.setState((currentState) => ({
      user: {
        ...currentState.user,
        eeaCheckbox: !this.state.user.eeaCheckbox,
      },
    }));
  };

  handleUser = (userData) => {
    if (this.props.modifyUser) {
      const current = this.state.user;
      const mapped = this.mapModifyUserIdentityFields(userData, current);
      this.setState({ user: { ...current, ...mapped } });
      return;
    }
    this.setState({ user: { ...this.state.user, ...userData } });
  };

  handleSetPaScreeningFiles = (files) => {
    this.setState({ user: { ...this.state.user, paScreeningFiles: files } });
  };

  render() {
    const {
      t,
      showAllUsers,
      i18n,
      selectedIndex,
      modifyUser,
      showDeleteUser,
      userNumber,
      accesses,
    } = this.props;

    const { language } = i18n;

    const {
      submit,
      showUK,
      showAPAC,
      showEurozone,
      invalidYear,
      error,
      users,
      user,
      displayaccess,
      displayuserModal,
      editaccess,
      accessobj,
      showAccessModal,
      edit,
      newuseraccess,
    } = this.state;

    const { firstName, lastName, country, access, selfenroll, userId } = user;
    const shouldSkipAccessValidationForModify = this.shouldSkipAccessValidationForModify();
    const shouldValidateAccess =
      submit && access.length < 1 && !shouldSkipAccessValidationForModify;

    return (
      <>
        <section id="new-user-page" className="mainBody">
          <div className={showAllUsers ? "" : "container"}>
            <div className="row">
              <div className="col-xs-12">
                {!showAllUsers && (
                  <>
                    <Heading
                      level={1}
                      headingStyle={"heading5"}
                      className="margin-1-b"
                    >
                      {modifyUser
                        ? t("newuser.modifyheading")
                        : t("newuser.heading")}
                    </Heading>
                  </>
                )}

                <div className="card card-rounded pad-2">
                  <div className="row">
                    <div className="col-xs-12">
                      <Heading
                        level={4}
                        className={"heading-4 dls-deep-blue pad-1-b"}
                      >
                        {t("newuser.userdetails")} {userNumber && userNumber}
                      </Heading>
                    </div>
                  </div>

                  <RadioGroup
                    onChange={(event) => {
                      this.updateSavobj("selfenroll", event.target.value);
                    }}
                    className="pad-2-b"
                  >
                    <div className="row">
                      <div className="col-md-6 col-xs-12">
                        <RadioButton
                          id={`radio${selectedIndex}`}
                          label={
                            modifyUser
                              ? t("newuser.modifycheck1")
                              : t("newuser.check1")
                          }
                          value="1"
                          checked={selfenroll === "1"}
                        />
                        {!modifyUser && (
                          <div className="paInfoBubble">
                            <Tooltip
                              id="tooltip-default-top"
                              triggerElement={
                                <TooltipButton
                                  icon={<GlyphInfo />}
                                  tabIndex="-1"
                                />
                              }
                              placement="bottom"
                            >
                              {t("newuser.infoBubbleCheck1")}
                            </Tooltip>
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 col-xs-12">
                        <RadioButton
                          id={`${selectedIndex}radio`}
                          label={
                            modifyUser
                              ? t("newuser.modifycheck2")
                              : t("newuser.check2")
                          }
                          value="2"
                          checked={selfenroll === "2"}
                        />
                      </div>
                    </div>
                  </RadioGroup>

                  {submit && selfenroll === "" && (
                    <Alert status="error">{t("newuser.choose")}</Alert>
                  )}

                  <hr />

                  <div className="row pad-1-t">
                    {/* COUNTRY OF VERIFICATION STARTS */}
                    <div className="col-md-6 col-xs-12">
                      <div id="country-verification">
                        <Label className="label-3">
                          {t("newuser.country")}
                        </Label>

                        <CountryDropdown
                          country={country}
                          handleCountrySelectChange={this.updateSavobj}
                          languageSelected={language}
                        />

                        {submit && country === "" && language === "en" && (
                          <Alert status="error">
                            {t("newuser.country")} {t("newuser.required")}
                          </Alert>
                        )}

                        {submit && country === "" && language === "jap" && (
                          <Alert status="error">
                            {t("newuser.countryRequired")}
                          </Alert>
                        )}
                      </div>
                    </div>
                    {/* ENDS OF COUNTRY OF VERIFICATION */}

                    {/* USER ID FOR MODIFY JOURNEY STARTS */}
                    {modifyUser && (
                      <div className="col-md-6 col-xs-12">
                        <Label className="label-3">
                          {showUK ? t("newUserUK.userId") : t("newuser.userid")}
                        </Label>

                        <Input
                          aria-label="userid"
                          value={userId}
                          onChange={(event) => {
                            this.updateSavobj("userId", event.target.value);
                          }}
                        />

                        {submit && userId === "" && showAPAC && (
                          <Alert status="error">
                            {t("deleteuser.useridrequired")}
                          </Alert>
                        )}

                        {!userId.match(REGEX.USER_ID) && (
                          <Alert status="error">
                            {t("deleteuser.useriderror")}
                          </Alert>
                        )}
                      </div>
                    )}
                    {/* END OF USER ID FOR MODIFY JOURNEY */}
                  </div>

                  {/* APAC Form */}
                  {showAPAC && (
                    <APACForm
                      language={language}
                      submit={submit}
                      getDetails={this.getDetails}
                      modifyUser={modifyUser}
                      selfenroll={selfenroll}
                      users={users}
                      updateSavobj={this.updateSavobj}
                      updateadd={this.updateadd}
                      editSavobj={this.editSavobj}
                      error={error}
                      user={user}
                      setPaScreeningFiles={this.handleSetPaScreeningFiles}
                      mailext={this.props.mailext}
                    />
                  )}
                  {/* End of APAC Form */}

                  {/* UK Form */}
                  {showUK && (
                    <UKForm
                      language={language}
                      getDetails={this.getDetails}
                      modifyUser={modifyUser}
                      submit={submit}
                      user={user}
                      updateSavobj={this.updateSavobj}
                      error={error}
                      onChangeTitle={this.onChangeTitle}
                      getFile={this.getFile}
                      getEeaFile={this.getEeaFile}
                      invalidYear={invalidYear}
                      handleNameProofCheckbox={this.handleNameProofCheckbox}
                      handleEEAProofCheckbox={this.handleEEAProofCheckbox}
                      mailext={this.props.mailext}
                    />
                  )}
                  {/* End of UK Form */}

                  {showEurozone && (
                    <FormikContainer
                      ref={this.formikRef}
                      handleUser={this.handleUser}
                      language={language}
                      modifyUser={modifyUser}
                      user={user}
                      userIndex={selectedIndex}
                    />
                  )}
                  <section id="save-country-access" className="countrySaveList">
                    <div className="row">
                      <div className="col-xs-12">
                        <div className="savedAccessDiv">
                          {access.length > 0 && displayaccess ? (
                            <div className="card card-rounded pad-2">
                              <h4 className="label-3">
                                {t("access.accesssaved")}
                              </h4>
                              <ol className="pad-0-l">
                                {access.map((acc, index) => (
                                  <li className="accessList" key={index}>
                                    <span>
                                      {acc.country ===
                                      t("access.NEWZEALAND") ? (
                                        <img
                                          src={require(
                                            `../../assets/New ZeaLand.png`,
                                          )}
                                          alt="countryflag"
                                          style={{ paddingRight: "5px" }}
                                        />
                                      ) : acc.country ===
                                        t("access.AUSTRALIA") ? (
                                        <img
                                          src={require(
                                            `../../assets/Australia.svg`,
                                          )}
                                          alt="countryflag"
                                          style={{ paddingRight: "5px" }}
                                        />
                                      ) : acc.country ===
                                        t("access.HONGKONG") ? (
                                        <img
                                          src={require(
                                            `../../assets/Hong Kong.svg`,
                                          )}
                                          alt="countryflag"
                                          style={{ paddingRight: "5px" }}
                                        />
                                      ) : acc.country === t("access.INDIA") ? (
                                        <img
                                          src={require(
                                            `../../assets/India.svg`,
                                          )}
                                          alt="countryflag"
                                          style={{ paddingRight: "5px" }}
                                        />
                                      ) : acc.country === t("access.JAPAN") ? (
                                        <img
                                          src={require(
                                            `../../assets/Japan.svg`,
                                          )}
                                          alt="countryflag"
                                          style={{ paddingRight: "5px" }}
                                        />
                                      ) : acc.country ===
                                        t("access.SINGAPORE") ? (
                                        <img
                                          src={require(
                                            `../../assets/Singapore.svg`,
                                          )}
                                          alt="countryflag"
                                          style={{ paddingRight: "5px" }}
                                        />
                                      ) : acc.country === t("access.TAIWAN") ? (
                                        <img
                                          src={require(
                                            `../../assets/Taiwan.svg`,
                                          )}
                                          alt="countryflag"
                                          style={{ paddingRight: "5px" }}
                                        />
                                      ) : acc.country ===
                                        t("access.THAILAND") ? (
                                        <img
                                          src={require(
                                            `../../assets/Thailand.svg`,
                                          )}
                                          alt="countryflag"
                                          style={{ paddingRight: "5px" }}
                                        />
                                      ) : acc.country ===
                                        t("access.UNITEDKINGDOM") ? (
                                        <img
                                          src={require(
                                            `../../assets/United_Kingdom_Flag.svg`,
                                          )}
                                          alt="countryflag"
                                          style={{ paddingRight: "5px" }}
                                        />
                                      ) : null}
                                      {acc.country}
                                    </span>
                                    <span>
                                      {t("access.corporateId")}-{" "}
                                      {acc.controlAccountNumber}{" "}
                                    </span>
                                    <span
                                      className="undospan dls-bright-blue"
                                      onClick={() =>
                                        this.handleAddAccess(acc, index)
                                      }
                                    >
                                      {t("access.viewaccess")}
                                    </span>
                                    <span
                                      className="undospan dls-red"
                                      onClick={() => this.deleteAccess(index)}
                                    >
                                      {t("access.deleteaccess")}
                                    </span>
                                  </li>
                                ))}
                              </ol>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </section>

                  <div className="pad-2-t">
                    {shouldValidateAccess ? (
                      <Alert status="error">{t("access.fillaccess")}</Alert>
                    ) : null}

                    <Button onClick={this.handleAddAccess} className="addbtn">
                      <img
                        src={addIcon}
                        alt="Add Icon"
                        width="10"
                        className="pad-1-r"
                      />
                      {access.length > 0 && language === "en"
                        ? t("newuser.addaccess")
                        : modifyUser
                          ? t("access.modifyaccess")
                          : t("access.createaccess")}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {showAccessModal ? (
          <Modal>
            <ModalBody className="accessmodal">
              <div className="closebutton">
                <button onClick={this.toggleAccess}>
                  <img src={closeIcon} alt="close Icon" width="10" />
                </button>
              </div>
              <AddAccess
                editaccess={editaccess}
                accessobj={accessobj}
                getAccess={(value, accessEdit) => {
                  this.getAccessArray(value, accessEdit, users.length - 1);
                }}
                getValue={(value) => {
                  this.getValue(value);
                }}
                accesses={accesses}
                modifyUser={modifyUser ? true : false}
                language={language}
              />
            </ModalBody>
          </Modal>
        ) : null}

        <div className="accessOuterDiv" />

        <section id="continue-button" className="container">
          <div className="row">
            <div className="col-xs-12">
              <div>
                <Button
                  styleType="primary"
                  onClick={this.newAddUser}
                  className="btn submitBtn"
                >
                  {edit ? (
                    t("newuser.save")
                  ) : (
                    <>
                      <span style={{ padding: "10px" }}>
                        {t("access.submitaccess")}
                      </span>
                    </>
                  )}
                </Button>
              </div>

              {showDeleteUser && (
                <Button onClick={this.deleteUserDetails} className="addbtn">
                  <img src={addIcon} alt="Add Icon" width="10" />{" "}
                  <span style={{ color: "#006FCF", padding: "10px" }}>
                    {t("newuser.deleteDetails")}
                  </span>
                </Button>
              )}
            </div>
          </div>
        </section>

        {/* Popup : Final Summary for Country For Access  */}
        <div className="bottomLine">
          {newuseraccess && displayuserModal && (
            <Modal className="summaryModal">
              <ModalBody className="modalBody">
                <div className="modaladd">
                  <span>
                    <img
                      style={{ paddingTop: "5px" }}
                      src={TickIcon}
                      alt="successicon"
                    />
                    <h4 style={{ paddingTop: "5px" }}>
                      {t("newuser.user")} - {selectedIndex + 1}{" "}
                      {t("newuser.added")}
                    </h4>
                    <h4 style={{ paddingTop: "5px" }}>
                      {t("newuser.username")} {selectedIndex + 1} -{" "}
                      {language === "en"
                        ? `${firstName || user.currentFirstName || ""} ${lastName || user.currentFullLastName || ""} `
                        : `${lastName || user.currentFullLastName || ""} ${firstName || user.currentFirstName || ""} `}
                    </h4>
                  </span>
                  {user.country !== t("access.UNITEDKINGDOM") &&
                    !modifyUser && (
                      <h4 style={{ paddingTop: "5px" }}>
                        <b> {t("newuser.accessdetails")}</b>
                      </h4>
                    )}
                  {access.length > 0 && (
                    <div className="countryOfAccessInfo">
                      {access.map((useracc, index) => (
                        <ol key={index}>
                          <li>
                            {access.indexOf(useracc) + 1}.
                            {useracc.country === t("access.NEWZEALAND") ? (
                              <img
                                src={require(`../../assets/New ZeaLand.png`)}
                                alt="countryflag"
                              />
                            ) : useracc.country === t("access.AUSTRALIA") ? (
                              <img
                                src={require(`../../assets/Australia.svg`)}
                                alt="countryflag"
                              />
                            ) : useracc.country === t("access.HONGKONG") ? (
                              <img
                                src={require(`../../assets/Hong Kong.svg`)}
                                alt="countryflag"
                              />
                            ) : useracc.country === t("access.INDIA") ? (
                              <img
                                src={require(`../../assets/India.svg`)}
                                alt="countryflag"
                              />
                            ) : useracc.country === t("access.JAPAN") ? (
                              <img
                                src={require(`../../assets/Japan.svg`)}
                                alt="countryflag"
                              />
                            ) : useracc.country === t("access.SINGAPORE") ? (
                              <img
                                src={require(`../../assets/Singapore.svg`)}
                                alt="countryflag"
                              />
                            ) : useracc.country === t("access.TAIWAN") ? (
                              <img
                                src={require(`../../assets/Taiwan.svg`)}
                                alt="countryflag"
                              />
                            ) : useracc.country === t("access.THAILAND") ? (
                              <img
                                src={require(`../../assets/Thailand.svg`)}
                                alt="countryflag"
                              />
                            ) : useracc.country ===
                              t("access.UNITEDKINGDOM") ? (
                              <img
                                src={require(
                                  `../../assets/United_Kingdom_Flag.svg`,
                                )}
                                alt="countryflag"
                              />
                            ) : null}
                            <span>{useracc.country}</span>
                            <span>
                              {t("access.corporateId")} -{" "}
                              {useracc.controlAccountNumber}
                            </span>
                          </li>
                        </ol>
                      ))}
                    </div>
                  )}
                </div>
              </ModalBody>

              <ModalFooter className="modalfooter">
                <Button className="userBtn" onClick={this.ModalShow}>
                  {modifyUser
                    ? t("newuser.viewModifiedUsers")
                    : t("newuser.viewUsers")}
                </Button>
              </ModalFooter>
            </Modal>
          )}
        </div>
      </>
    );
  }
}

export default withTranslation("common")(PersonalDetails);
export { PersonalDetails as UnwrappedPersonalDetails };
